import Request from '@hotmart/request'
import { CHAT_REQUEST_IDENTIFIERS } from './chat.constants'

Request.register(`${process.env.API_C3P0_CONVERSATION}/v1`, {
  get: {
    [CHAT_REQUEST_IDENTIFIERS.UNREAD_MESSAGES]: '/messages/unread',
    [CHAT_REQUEST_IDENTIFIERS.USER_ME]: '/contacts/me'
  }
})
